import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51')
];

export const server_loads = [];

export const dictionary = {
		"/": [18],
		"/about": [40],
		"/(authenticated)/account": [19,[2,3]],
		"/(authenticated)/account/[tab]": [20,[2,3,4]],
		"/confirm": [41],
		"/(authenticated)/dashboard": [21,[2]],
		"/(authenticated)/experimental": [22,[2,5]],
		"/(authenticated)/experimental/agents": [23,[2,5,6]],
		"/(authenticated)/experimental/agents/[tab]": [24,[2,5,6]],
		"/(authenticated)/experimental/float": [25,[2,5]],
		"/(authenticated)/experimental/hewsync": [26,[2,5,7]],
		"/(authenticated)/experimental/queue": [27,[2,5,8]],
		"/features": [42],
		"/forgot-password": [43],
		"/iframe": [44],
		"/login-as": [46],
		"/login": [45],
		"/logout": [47],
		"/markdown-preview": [48],
		"/reset-password": [49],
		"/share": [50,[],[17]],
		"/signup": [51],
		"/(authenticated)/[organization=organization]": [28,[2,9]],
		"/(authenticated)/[organization=organization]/api": [29,[2,9,10]],
		"/(authenticated)/[organization=organization]/api/[kind]/[id]/[[tab]]": [30,[2,9,10,11,12]],
		"/(authenticated)/[organization=organization]/dashboard": [31,[2,9]],
		"/(authenticated)/[organization=organization]/project/[id]/atom": [32,[2,9,13]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/chats/[chat]": [33,[2,9,13]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/plans/[plan]": [34,[2,9,13]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/reports/[report]": [35,[2,9,13]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/[...path]": [36,[2,9,13]],
		"/(authenticated)/[organization=organization]/project/[id]/[...page]": [37,[2,9,14]],
		"/(authenticated)/[organization=organization]/[slug=perms]": [38,[2,9,15]],
		"/(authenticated)/[organization=organization]/[slug=perms]/[id]/[[tab]]": [39,[2,9,15,16]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';